import React, { useState, useMemo, useEffect } from "react";
import styles from "../Secure.module.scss";
import { TablePagination } from "@mui/material";
import { SearchBar } from "../controls/SearchBar";
import { UserListingItem } from "./TopProfile";
import { UserStatisticsListing } from "./components/UserStatisticsListings";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { Methods, useFetch } from "../../../hooks/useFetch";
import { Autocomplete, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";

interface UserListingProps {
  users: Array<UserListingItem>;
}

interface League {
  id: string | number;
  name: string;
}

interface Country {
  id: string | number;
  name: string;
}

const WhiteTextField = styled(TextField)({
  "& .MuiInputBase-root": {
    color: "white",
  },
  "& .MuiInputLabel-root": {
    color: "white",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "white",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "white",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "white",
  },
  "& .MuiSvgIcon-root": {
    color: "white",
  },
});

export const StatisticsListings: React.FC<UserListingProps> = ({ users }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [gameType, setGameType] = useState(false);

  const [filterType, setFilterType] = useState("");
  const [selectedFilter, setSelectedFilter] = useState("");
  const [selectedNameTeam, setSelectedNameTeam] = useState("");

  const [selectedFilterGame, setSelectedFilterGame] = useState("");

  const [showGameType, setShowGameType] = useState(false);

  const [countries, setCountries] = useState<Country[]>([]);
  const [leagues, setLeagues] = useState<League[]>([]);

  const [displayUsers, setDisplayUsers] = useState<UserListingItem[]>(users);

  const gameTypeOptions = [
    { id: "game1_1", label: "1 (Match Outcome)" },
    { id: "game1_x", label: "X (Match Outcome)" },
    { id: "game1_2", label: "2 (Match Outcome)" },

    { id: "game2_1", label: "Under 2.5 (Over/Under)" },
    { id: "game2_2", label: "Over 2.5 (Over/Under)" },

    { id: "game3_11", label: "1-1 (Correct Score)" },
    { id: "game3_1x", label: "1-X (Correct Score)" },
    { id: "game3_12", label: "1-2 (Correct Score)" },
    { id: "game3_x1", label: "X-1 (Correct Score)" },
    { id: "game3_xx", label: "X-X (Correct Score)" },
    { id: "game3_x2", label: "X-2 (Correct Score)" },
    { id: "game3_21", label: "2-1 (Correct Score)" },
    { id: "game3_2x", label: "2-X (Correct Score)" },
    { id: "game3_22", label: "2-2 (Correct Score)" },

    { id: "game4_gg", label: "Both Teams To Score" },
    { id: "game4_ng", label: "Both Teams Not To Score" },
  ];

  console.log(selectedFilter, "selectedFilter-aaaa");

  const { makeRequest: fetchCountries } = useFetch(`/api/models/countries`, {
    method: Methods.GET,
  });

  const { makeRequest: fetchLeagues } = useFetch(`/api/models/leagues`, {
    method: Methods.GET,
  });

  const { makeRequest: fetchStatisticLeague } = useFetch(
    `/api/view_statistics_by?league_id=${selectedFilter}&game_type=${selectedFilterGame}`,
    {
      method: Methods.GET,
    }
  );

  const { makeRequest: fetchStatisticCountry } = useFetch(
    `/api/view_statistics_by?country_id=${selectedFilter}&game_type=${selectedFilterGame}`,
    {
      method: Methods.GET,
    }
  );

  const { makeRequest: fetchGameType } = useFetch(
    `/api/view_statistics_by?game_type=${selectedFilter}`,
    {
      method: Methods.GET,
    }
  );

  // Fetch filter options
  useEffect(() => {
    if (filterType === "Country") {
      fetchCountries()
        .then((res) => {
          if (res?.data) setCountries(res.data.data as Country[]);
        })
        .catch((err) => console.error("Failed to fetch countries:", err));
    }

    if (filterType === "League") {
      fetchLeagues()
        .then((res) => {
          if (res?.data) setLeagues(res.data.data as League[]);
        })
        .catch((err) => console.error("Failed to fetch leagues:", err));
    }
  }, [filterType]);

  useEffect(() => {
    if (!selectedFilter || !filterType) {
      setDisplayUsers(users);
      return;
    }

    const fetchStats = async () => {
      try {
        let res;

        console.log("filterType", filterType);
        if (gameType && filterType === "League") {
          res = await fetchStatisticLeague();
        } else if (gameType && filterType === "Country") {
          res = await fetchStatisticCountry();
        }

        if (res?.data) {
          const data = res.data.data as UserListingItem[];
          setDisplayUsers(data);
        }
      } catch (err) {
        console.error("Failed to fetch statistics:", err);
      }
    };

    fetchStats();
  }, [selectedFilter, filterType, users, selectedFilterGame]);

  useEffect(() => {
    if (
      (filterType === "League" || filterType === "Country") &&
      selectedFilter
    ) {
      setShowGameType(true);
    } else {
      setShowGameType(false);
    }
  }, [filterType, selectedFilter]);

  const filteredUsers = useMemo(() => {
    return displayUsers.filter((user) =>
      user.username.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [searchTerm, displayUsers]);

  const paginatedUsers = useMemo(() => {
    const start = page * rowsPerPage;
    return filteredUsers.slice(start, start + rowsPerPage);
  }, [page, rowsPerPage, filteredUsers]);

  const handlePageChange = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  if (!displayUsers.length) {
  }

  return (
    <>
      <div
        className={styles.topPart}
        style={{ display: "flex", alignItems: "center", gap: "5px" }}
      >
        <SearchBar
          className={styles.searchUsersSearch}
          searchTerm={searchTerm}
          searchLabel={"Search by username"}
          setSearchTerm={setSearchTerm}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            gap: "10px",
          }}
        >
          <Autocomplete
            disableClearable
            options={["Country", "League"]}
            value={filterType}
            onChange={(event, newValue) => {
              if (newValue !== filterType) {
                setFilterType(newValue || "");
                setSelectedFilter(""); // OK to reset here
                setSelectedFilterGame(""); // Add this
                setGameType(false);
              }
            }}
            sx={{ width: 145 }}
            renderInput={(params) => (
              <WhiteTextField
                {...params}
                label="Choose Filter"
                variant="outlined"
                size="small"
              />
            )}
          />

          {filterType === "Country" && (
            <Autocomplete
              options={countries}
              getOptionLabel={(option) => option.name}
              value={
                countries.length > 0
                  ? countries.find((c) => c.id.toString() === selectedFilter)
                  : null
              }
              onChange={(event, newValue) => {
                setSelectedFilter(newValue ? newValue.id.toString() : "");
              }}
              sx={{ width: 190 }}
              renderInput={(params) => (
                <WhiteTextField
                  {...params}
                  label="Select Country"
                  variant="outlined"
                  size="small"
                />
              )}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              clearOnEscape
            />
          )}

          {filterType === "League" && (
            <Autocomplete
              options={leagues}
              getOptionLabel={(option) => option.name}
              value={leagues.find((l) => l.id === selectedFilter) || null}
              onChange={(event, newValue) => {
                setSelectedFilter(newValue ? newValue.id.toString() : "");
              }}
              sx={{ width: 190 }}
              renderInput={(params) => (
                <WhiteTextField
                  {...params}
                  label="Select League"
                  variant="outlined"
                  size="small"
                />
              )}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              clearOnEscape
            />
          )}
        </div>
        {showGameType && (
          <Autocomplete
            options={gameTypeOptions}
            getOptionLabel={(option) => option.label}
            value={
              gameTypeOptions.find((opt) => opt.id === selectedFilterGame) ||
              null
            }
            onChange={(event, newValue) => {
              if (newValue) {
                setSelectedFilterGame(newValue.id);
                setGameType(true);
              }
            }}
            sx={{ width: 190 }}
            renderInput={(params) => (
              <WhiteTextField
                {...params}
                label="Select Game Type"
                variant="outlined"
                size="small"
              />
            )}
            clearOnEscape
            disableClearable={false}
          />
        )}
      </div>
      {!displayUsers.length && (
        <div className={styles.userListingNotFound}>Users not found</div>
      )}

      <div className={styles.searchUsersListing}>
        {paginatedUsers.map((user, index) => (
          <UserStatisticsListing
            avg_odd={user.avg_odd}
            success_rate={user.success_rate}
            number_of_bets={user.number_of_bets}
            id={user.id}
            username={user.username}
            followed={user.followed}
            created_at={user.created_at}
            name={user.name}
            key={index}
          />
        ))}
      </div>

      <TablePagination
        component="div"
        count={filteredUsers.length}
        className={styles.searchUsersPagination}
        page={page}
        onPageChange={handlePageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleRowsPerPageChange}
        labelRowsPerPage="Rows per page:"
      />
    </>
  );
};
